import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './stockUpload.module.css';

// Машины, к которым есть замечание, списком: раньше плашка называла только число,
// и искать эти машины приходилось в базе по VIN из выгрузки. VIN ведёт в карточку
// машины — туда, где заполняется объём
const CarList = ({ cars }) => {
  if (!cars.length) return null;
  return (
    <details className={styles.noticeCars}>
      <summary>Показать машины ({cars.length})</summary>
      <ul>
        {cars.map((c, i) => (
          <li key={`${c.fileName}-${c.row}-${c.kind}-${i}`}>
            {c.carId ? (
              <Link to={`/cars/car/${c.carId}/main-data`}>{c.vin || `машина ${c.carId}`}</Link>
            ) : (
              <b>{c.vin || 'без VIN'}</b>
            )}{' '}
            — {[c.markName, c.modelName, c.complectationName].filter(Boolean).join(' ')}
            {c.issueYear ? `, ${c.issueYear}` : ''}
            {c.cityName ? `, ${c.cityName}` : ''}
            {c.row ? ` · строка ${c.row}` : ''}
          </li>
        ))}
      </ul>
    </details>
  );
};

// Три плашки под итогами импорта; одни и те же для успешного и неуспешного результата
const StockImportNotices = ({ result }) => {
  const navigate = useNavigate();
  const of = (kind) => (result.carWarnings || []).filter((w) => w.kind === kind);

  return (
    <>
      {/* Машины без правила приехали с ценой поставщика и уже видны в приложении —
          это ровно та кривая цена, ради которой заводился прайс. Молчать о ней нельзя:
          иначе она всплывёт, только если кто-то сам заглянет в экран прайса */}
      {result.noPriceRule > 0 && (
        <div className={styles.noRuleNotice}>
          {result.noPriceRule} машин приехали с ценой поставщика — под них нет правила в прайсе.{' '}
          <button type="button" onClick={() => navigate('/price-list')}>
            Открыть прайс по приказу
          </button>
          <CarList cars={of('noPriceRule')} />
        </div>
      )}
      {/* Цены нет ни в файле, ни у менеджера. Машина в стоке, но с нулём — и об этом
          надо сказать громче, чем про цену поставщика: ноль виден клиенту */}
      {result.noPrice > 0 && (
        <div className={styles.noRuleNotice}>
          {result.noPrice} машин импортированы без цены — её нет ни в выгрузке, ни в прайсе по приказу. В стоке они
          стоят 0 ₸, пока не появится правило.{' '}
          <button type="button" onClick={() => navigate('/price-list')}>
            Завести правило в прайсе
          </button>
          <CarList cars={of('noPrice')} />
        </div>
      )}
      {/* Объём не пришёл ни из выгрузки, ни из комплектации. Банки ищут модель по
          объёму, и заявка по такой машине не уйдёт — а менеджер узнал бы об этом только
          из карточки машины, уже на сделке */}
      {result.noEngineVolume > 0 && (
        <div className={styles.noRuleNotice}>
          {result.noEngineVolume} машин без объёма двигателя — заявка по ним не уйдёт в банки. Заполните объём в карточке
          машины (в см³, например 1499).
          <CarList cars={of('noEngineVolume')} />
        </div>
      )}
    </>
  );
};

export default StockImportNotices;
